import { hideLoader, showLoader } from "./loaderSlice";

export const startShowLoader = () => {
    return async( dispatch ) => {
        dispatch( showLoader() );
    }
}

export const stopShowLoader = () => {
    return async( dispatch ) => {
        dispatch( hideLoader() );
    }
}
